import {Action as ButtonAction, Button, Payload} from '../actions/Button';
import {ActionSetWithChildren} from './helper';

export function getSingleButton(
  action: ActionSetWithChildren,
  button: Button,
  subgroups: string[],
  updateCb: (newPayload: Payload) => void,
): Payload {
  action.addChild(button, action.group, subgroups);

  const {id, label, primary, disabled} = button;
  const singleButton = {
    disabled,
    id,
    label,
    primary,
  };

  action.subscribeToChild(button, ButtonAction.UPDATE, updateCb);

  return singleButton;
}



// WEBPACK FOOTER //
// ./src/actions/buttonHelper.ts